import React from 'react';

import { endOfDay, startOfDay } from 'date-fns';

import { thisYear } from 'constants/ProjectConstants';
import { getDateRangeFromLSBasedOnEndDateStartDate } from 'constants/helper';
import { localStorageKeys } from 'constants/localStorageKeys';

import { DatePicker } from 'uiToolkitV1/DatePicker';
import InputLabel from 'uiToolkitV1/InputLabel';

export const InitiativeDueDate = ({
  startTS = new Date(),
  dueTS,
  onChange = () => {},
  timeBoundDetails,
  isReadOnly,
  showLabel = false,
  labelText = 'Due by',
  isClearable = false,
}) => {
  const dateRange =
    getDateRangeFromLSBasedOnEndDateStartDate(localStorageKeys?.rabbitInitiativeAnalyticsFilters) ?? thisYear;

  const dueDate = dueTS ? endOfDay(new Date(dueTS)) : null;
  const minDate = startOfDay(new Date(startTS));
  const maxDate = endOfDay(new Date(dateRange.endDate));

  const handleDateChange = (selectedDate) => {
    onChange(selectedDate.setHours(23, 59, 59).valueOf());
  };

  const handleOnClear = () => {
    onChange(null);
  };

  if (showLabel) {
    return (
      <InputLabel labelText={labelText}>
        <DatePicker
          onChange={handleDateChange}
          selectedDate={dueDate}
          popperPlacement="top"
          disabled={isReadOnly}
          minDate={minDate}
          maxDate={maxDate}
          customInputProps={{ isClearableFromCalendar: isClearable, handleOnClear }}
        />
      </InputLabel>
    );
  }
  return (
    <DatePicker
      onChange={handleDateChange}
      selectedDate={dueDate}
      popperPlacement="top"
      disabled={isReadOnly}
      minDate={minDate}
      maxDate={maxDate}
      customInputProps={{ isClearableFromCalendar: isClearable, handleOnClear }}
    />
  );
};
